import React from 'react'
import { Box, Typography } from '@mui/material'
import { muiColors } from '@zuto/theme/src/mui/DefaultTheme'
import CheckedList from '../../../CheckedList'
import { fonts } from '@zuto/theme/src/mui/Typography'
import { KnownSource } from '../../../../types/Source'

type WhyCustomersLoveZutoProps = {
  source: KnownSource
}

const CARMOOLA_CHECKLIST_CONTENT: string[] = [
  'Get a quick decision',
  '£0 deposit options available',
  'Fast, friendly support from real people'
]

const FALLBACK_CHECKLIST_CONTENT: string[] = [
  '£0 deposit options available',
  'Fast, friendly support from real people',
  "We'll help you find and finance your perfect car"
]

const SOURCE_CHECKLIST_CONTENT: Partial<Record<KnownSource, string[]>> = {
  carmoola: CARMOOLA_CHECKLIST_CONTENT
}

const getChecklistContent = (source: KnownSource): string[] =>
  (source && SOURCE_CHECKLIST_CONTENT[source]) || FALLBACK_CHECKLIST_CONTENT

const emojiIconsBase = ['💛', '🚗', '⚡️']

export const WhyCustomersLoveZuto: React.FC<WhyCustomersLoveZutoProps> = ({ source }) => {
  const checkListContent = getChecklistContent(source)
  const emojiIcons = emojiIconsBase
    .slice(0, checkListContent.length)
    .map((e, i) => (
      <span key={`${i}-why-choose-zuto-emoji`} aria-hidden style={{ paddingRight: 5 }}>
        {e}
      </span>
    ))

  return (
    <Box
      sx={{ backgroundColor: muiColors.prominentColors.lightBlue, borderRadius: { md: '16px' } }}
      p={5}
      mt={5}
      mb={8}
    >
      <Typography
        variant="rowHeading"
        sx={{ fontFamily: fonts.bold }}
        mb={0}
        align="center"
      >
        Why over 5m customers choose Zuto
      </Typography>
      <CheckedList
        list={checkListContent}
        icons={emojiIcons}
        textVariant="labelLarge"
        darkerText
        textCentered
      />
    </Box>
  )
}
